import type { JSX } from 'react';
import { Seo } from '@/components/seo';
import { ShowingRequestsPanel } from '@/components/dashboard/showings/ShowingRequestsPanel';

export function DashboardShowingRequests(): JSX.Element {
  return (
    <section className="flex flex-col gap-xl py-8">
      <Seo
        title="Showing Requests"
        description="Review and approve showing requests."
        canonicalPath="/dashboard/showings/requests"
        noIndex
      />

      <header className="flex flex-col gap-xs">
        <h1 className="text-2xl font-semibold text-brand-primary md:text-3xl">Showing Requests</h1>
        <p className="text-sm text-text-primary/70">
          Approve, deny, and reschedule requested showings. Only administrators and managers can
          take action.
        </p>
      </header>

      <ShowingRequestsPanel />
    </section>
  );
}
